module.exports = __webpack_public_path__ + "img/_ABS9815(1).3d1b7bae.jpg";